import { Body2, Link, TableCell, TableRow } from '@sainsburys-tech/fable'
import { SparkFilled } from '@sainsburys-tech/icons'
import React from 'react'

import { setCurrentPlanner } from '../../../utils/localStore'
import { IForecastReason } from '../../types/IForecastReason'
import IMixSku from '../../types/IMixSku'

interface IProps {
  openQpig: (mixSku: IMixSku) => void
  mixSku: IMixSku
  forecastReasons?: IForecastReason[]
}

const MixSkusRowCompleted = (props: IProps) => {
  const { mixSku, openQpig, forecastReasons } = props

  return (
    <TableRow key={mixSku.mixSkuId} id={`MixSkuId_${mixSku.mixSkuId}`}>
      <TableCell>
        <Link
          className='c-common-hover-over-cursor c-link-black'
          onClick={() => {
            setCurrentPlanner('bakery')
            openQpig(mixSku)
          }}
          testid='completed-mix-link'
        >
          <Body2>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span>{mixSku.skuName}</span>
              {mixSku.isCredibleProduct === true && (
                <SparkFilled className='c-star__icon' />
              )}
            </span>
          </Body2>
        </Link>
      </TableCell>
      <TableCell>
        <Body2>{mixSku.productionTarget}</Body2>
      </TableCell>
      <TableCell>
        <Body2>{mixSku.productionActual}</Body2>
      </TableCell>
      {forecastReasons && (
        <TableCell>
          <Body2>
            {
              forecastReasons?.find(
                (reason) => reason.forecastReasonId === mixSku.forecastReasonId,
              )?.description
            }
          </Body2>
        </TableCell>
      )}
    </TableRow>
  )
}

export default MixSkusRowCompleted
